<div class="cr02-dlg" [attr.data-type]="type" [attr.data-mode]="mode" role="dialog" aria-modal="true">
  <h3 class="cr02-dlg-title">{{ title }}</h3>
  <p class="cr02-dlg-msg" *ngIf="message">{{ message }}</p>

  <div class="cr02-dlg-field" *ngIf="mode === 'prompt' || mode === 'prompt-dual'">
    <label *ngIf="inputLabel">{{ inputLabel }}</label>
    <input
      class="cr02-dlg-input"
      type="text"
      [placeholder]="inputPlaceholder"
      [(ngModel)]="inputValue"
      (keydown.enter)="mode === 'prompt' ? onConfirm() : null"
      (input)="inputError = false"
      autofocus>
    <span class="cr02-dlg-error" *ngIf="inputError">This field is required</span>
  </div>

  <div class="cr02-dlg-field" *ngIf="mode === 'prompt-dual'">
    <label *ngIf="inputLabel2">{{ inputLabel2 }}</label>
    <input
      class="cr02-dlg-input"
      type="text"
      [placeholder]="inputPlaceholder2"
      [(ngModel)]="inputValue2"
      (keydown.enter)="onConfirm()"
      (input)="inputError2 = false">
    <span class="cr02-dlg-error" *ngIf="inputError2">This field is required</span>
  </div>

  <div class="cr02-dlg-actions">
    <button
      type="button"
      class="cr02-dlg-btn cr02-dlg-btn-ghost"
      *ngIf="mode === 'confirm' || mode === 'prompt' || mode === 'prompt-dual'"
      (click)="onCancel()">
      {{ cancelText }}
    </button>
    <button
      type="button"
      class="cr02-dlg-btn"
      [class.cr02-dlg-btn-primary]="confirmTone === 'brand'"
      [class.cr02-dlg-btn-success]="confirmTone === 'success'"
      [class.cr02-dlg-btn-danger]="confirmTone === 'danger' || danger"
      (click)="onConfirm()">
      {{ confirmText }}
    </button>
  </div>
</div>
